import {Col, Row, Select, Drawer, Button} from "antd";
import {MenuOutlined} from "@ant-design/icons";
import React, {useState, useEffect, useRef} from "react";

export const CustomerMapFilters = ({
    dedicatedCompanyIds,
    dedicatedSubCompanyIds,
    setDedicatedCompanyIds,
    setDedicatedSubCompanyIds,
    companyOptions,
    subCompanyOptions
}) => {
    const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);
    const [mapContainer, setMapContainer] = useState(null);

    useEffect(() => {
        const container = document.querySelector('[data-testid="map"]');
        setMapContainer(container);
    }, []);

    return (
        <div style={{position: "relative"}}>
            <Button
                icon={<MenuOutlined />}
                onClick={() => setFilterDrawerVisible(true)}
                style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "1px solid #d9d9d9",
                    borderRadius: "6px",
                    padding: "4px 15px",
                    fontSize: "14px",
                    height: "auto"
                }}
                data-testid="filter-button"
            >
                Filtreler
            </Button>

            <Drawer
                placement="top"
                onClose={() => setFilterDrawerVisible(false)}
                visible={filterDrawerVisible}
                height="100px"
                bodyStyle={{padding: "12px", background: "rgba(255, 255, 255, 0.34)"}}
                getContainer={() => mapContainer || document.body}
                mask={false}
                style={{
                    position: "absolute"
                }}
                drawerStyle={{
                    backgroundColor: "rgba(255, 255, 255, 0.34)",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    position: "absolute"
                }}
            >
                <Row gutter={[16, 12]} style={{marginBottom: 0}}>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <h5>Firma Seçiniz</h5>
                        <Select
                            mode="multiple"
                            allowClear
                            showSearch
                            size="small"
                            style={{width: "100%"}}
                            placeholder="Firma Seçiniz"
                            value={dedicatedCompanyIds}
                            onChange={setDedicatedCompanyIds}
                            maxTagCount={2}
                            maxTagTextLength={15}
                            maxTagPlaceholder={omittedValues => `+${omittedValues.length} firma`}
                            options={companyOptions.map(c => ({
                                label: c.companyName,
                                value: c._id
                            }))}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <h5>Alt Firma Seçiniz</h5>
                        <Select
                            mode="multiple"
                            allowClear
                            showSearch
                            size="small"
                            style={{width: "100%"}}
                            placeholder="Alt Firma Seçiniz"
                            value={dedicatedSubCompanyIds}
                            onChange={setDedicatedSubCompanyIds}
                            maxTagCount={2}
                            maxTagTextLength={15}
                            maxTagPlaceholder={omittedValues => `+${omittedValues.length} şube`}
                            options={subCompanyOptions.map(s => ({
                                label: s.name,
                                value: s._id
                            }))}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>
                </Row>
            </Drawer>
        </div>
    );
};
